import { useEffect, useState } from 'react';
import TaskItem from './TaskItem';
import Hosts from '../../Hosts'
import { getTokenInfo } from './../../UseToken';

import {
    reqGET,
} from '../../Utils';


const TaskList = ({profile, userId, lang}) => {
    const [tasks, setTasks] = useState([]);
    const [showAllTasks, setShowAllTasks] = useState(false);

    useEffect(() => {
        const fetchTasks = async () => {
            try {
                const response = await reqGET(`${Hosts.SIMCore_API}/tarefa/${getTokenInfo().companycode}`);
                if (response?.data) {
        
                    //  tarefas com base no perfil do utilizador e userId
                    let filteredTasks;

                    if (profile === 'Administrador' || profile === 'Gestor de Conteúdos') {
                        filteredTasks = response.data; // Administradores e GdC vêm todas as tarefas
                    } else {
                        filteredTasks = response.data.filter(task =>
                            task.info.responsaveis.some(responsavel => responsavel.value === userId)
                        );
                    }

                    const combinedTasks = filteredTasks.map(task => ({
                        name: task.info.name,
                        dueDate: task.info.data_limite,
                        prioridade: task.info.prioridade?.value,
                    }))
                    .sort((a, b) => new Date(a.dueDate) - new Date(b.dueDate));
                    console.log(combinedTasks)
                    setTasks("antes do erro",combinedTasks);
                } else {
                    console.log("Nenhum dado de tasks foi retornado.");
                }
            } catch (error) {
                console.error("Erro ao ir buscar as tasks:", error);
            }
        };
        fetchTasks();
    }, [profile, userId]);


    // alternar entre mostrar todas as tarefas ou apenas as primeiras duas
    const handleShowAllTasks = () => {
        setShowAllTasks(!showAllTasks);
    };

    // selecionar as tarefas a serem mostradas
    const tasksToShow = Array.isArray(tasks) ? (showAllTasks ? tasks : tasks.slice(0, 2)) : [];

    return (
        <div 
        style={{ 
            maxHeight: '420px', 
            overflowY: 'auto', 
            overflowX: "hidden",
            borderRadius: '5px' 
        }}
        >
            {tasksToShow.length > 0 ? (
                tasksToShow.map((task, index) => (
                    <div 
                        key={index}                         
                        style={{ cursor: 'pointer' }}
                    >
                        <TaskItem name={task.name} dueDate={task.dueDate} status={task.prioridade} />
                        
                    </div>
                ))
            ) : (
                <p>Nenhuma tarefa encontrada.</p>
            )}
            
            {tasks.length > 2 && (
                <div className='mb-5' style={{ cursor: 'pointer', textAlign: 'center', marginTop: '10px', fontSize: '1.2rem' }} onClick={handleShowAllTasks}>
                    {showAllTasks ? "Fechar" : `+${tasks.length - 2} Tarefas`}
                </div>
            )}
        </div>
    );
};

export default TaskList;